<style>
@import url(assets/font/IRANSansDN/css/fontiran.css);

* {
  font-family: iransansdn;
  font-weight: 300;
}

#tsparticles {
  height: 100vh;
  width: 100vw;
  position: fixed;
}

.rocketchat-container {
  overflow: hidden;
}

.grecaptcha-badge {
  z-index: 3;
}

.main-card {
  margin-bottom: 50px;
}
</style>

<template>
  <v-app>
    <v-main>

      <Particles
          id="tsparticles"
          :options="{
            background: {
                color: {
                    value: '#6363cf'
                }
            },
            fpsLimit: 60,
            interactivity: {
                detectsOn: 'canvas',
                events: {
                    onHover: {
                        enable: true,
                        mode: 'repulse'
                    },
                    resize: true
                },
                modes: {
                    bubble: {
                        distance: 400,
                        duration: 2,
                        opacity: 0.8,
                        size: 40,
                        speed: 3
                    },
                    push: {
                        quantity: 4
                    },
                    repulse: {
                        distance: 200,
                        duration: 0.4
                    }
                }
            },
            particles: {
                color: {
                    value: '#ffffff'
                },
                links: {
                    color: '#ffffff',
                    distance: 150,
                    enable: true,
                    opacity: 0.5,
                    width: 1
                },
                collisions: {
                    enable: true
                },
                move: {
                    direction: 'none',
                    enable: true,
                    outMode: 'bounce',
                    random: false,
                    speed: 6,
                    straight: false
                },
                number: {
                    density: {
                        enable: true,
                        value_area: 800
                    },
                    value: 80
                },
                opacity: {
                    value: 0.5
                },
                shape: {
                    type: 'circle'
                },
                size: {
                    random: true,
                    value: 5
                }
            },
            detectRetina: true
        }"
      />

      <router-view/>

      <v-footer class="justify-center" dir="ltr" fixed>
        <v-col class="text-center">
          <v-spacer></v-spacer>
          <div>
            Copyright &copy; 2020 - {{ new Date().getFullYear() }}
            <a href="https://negarshowroom.com" target="_blank">Negar Showroom</a>. All rights reserved.
          </div>
        </v-col>
      </v-footer>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',


  data: () => ({
    //
  }),
  mounted() {
    //todo
  }
};
</script>
